export default __webpack_public_path__ + "static/media/copy-icon.c954834a.svg";